var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15794 3.13502C6.20587 3.09009 6.26217 3.05504 6.32364 3.03187C6.38512 3.00871 6.45055 2.99788 6.51621 3.00002C6.58187 3.00216 6.64646 3.01721 6.7063 3.04432C6.76614 3.07143 6.82005 3.11007 6.86494 3.15802L10.6149 7.15802C10.7018 7.2507 10.7502 7.37298 10.7502 7.50002C10.7502 7.62707 10.7018 7.74935 10.6149 7.84202L6.86494 11.842C6.82003 11.89 6.76612 11.9286 6.70628 11.9557C6.64645 11.9828 6.58186 11.9978 6.51621 11.9999C6.45056 12.0021 6.38513 11.9913 6.32366 11.9681C6.26219 11.945 6.20588 11.9099 6.15794 11.865C6.11001 11.8201 6.0714 11.7662 6.0443 11.7064C6.0172 11.6465 6.00216 11.5819 6.00002 11.5163C5.99788 11.4506 6.0087 11.3852 6.03185 11.3237C6.055 11.2623 6.09003 11.206 6.13495 11.158L9.56594 7.50002L6.13595 3.84202C6.09101 3.7941 6.05596 3.7378 6.03279 3.67632C6.00963 3.61485 5.99881 3.54941 6.00094 3.48376C6.00308 3.4181 6.01813 3.35351 6.04524 3.29367C6.07235 3.23383 6.10999 3.17992 6.15794 3.13502Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/_chevron-right.14c860b73b0077eef6e42d9a048c6a7b.svg";
export { ForwardRef as ReactComponent };